import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';
import { CoreService, DialogResult, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ResponseParserService } from 'src/app/services/response-parser.service';
import { AppDataService } from 'src/app/services/app-data.service';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { API_ENDPOINTS, API_ENDPOINT_KEYS } from 'src/app/constants/api-endpoints.constants';
import { ROUTE_CONSTANTS } from 'src/app/constants/route.constants';
import { FILTER_QUESTION_CODES, NAV_TAB_NUMBERS, PAGE_NUMBERS, POP_UP_CODES, QUESTION_CODES, SECTION_CODES } from 'src/app/constants/app-data.constants';

import { Mapper, MapperBuilder, TRANSFORM } from '../../helpers/mapper';
import { finalize, take } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { MonitorInvoiceExportGridFilterRequest } from '../../interfaces/monitor-invoice-export-grid-filter-request';

@Component({
  selector: 'app-exported-invoice-list',
  templateUrl: './exported-invoice-list.component.html',
  styleUrl: './exported-invoice-list.component.scss'
})
export class ExportedInvoiceListComponent extends BaseCardSetListComponent implements OnInit {

  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  filterQuestionToFilterModelMapper: Mapper;
  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private coreService: CoreService,
    private errorService: ErrorService,
  ) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.monitorInvoiceExportList,
      () => API_ENDPOINTS.dashboard.getExportedInvoices,
      false);

    this.filterQuestionToFilterModelMapper =
      new MapperBuilder()
        .WithDefaultTargetFieldMapping(/Filter$/i, "") // When target field name is not specified, just use the source field's name, but drop "Filter" from the end
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.batchId)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.batchName)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.batchRunFromDate, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.batchRunToDate, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.source)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.invoiceReference)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.invoiceStatus)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.invoiceDateFrom, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.invoiceDateTo, TRANSFORM.STRING_TO_DATE)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.oracleVendorId)
        .MapFrom(FILTER_QUESTION_CODES.monitorInvoiceExportListForm.vendorName)
        .BuildMapper();
  }

  ngOnInit(): void { }

  formLoad(event: any): void {
    this.loadGridDataOnFormLoad();
  }

  filterData(event: any): void {
    switch (event.field.key) {
      case QUESTION_CODES.monitorInvoiceExportListForm.monitorInvoiceExportListFilter:
        {
          const monitorInvoiceExportFilterRequest = this.getMonitorInvoiceExportFilterRequest();
          this.loadGridData(monitorInvoiceExportFilterRequest);
          break;
        }
    }
  }

  actionButton_monitorInvoiceExportGrid_datagrid_edit_Clicked(event: any) {
    this.router.navigate(['/', ROUTE_CONSTANTS.exportedInvoice.prefix, event.event.data.id]);
  }

  private getMonitorInvoiceExportFilterRequest(): MonitorInvoiceExportGridFilterRequest {
    const filterModel = this.getQuestionValue(
      this.model,
      NAV_TAB_NUMBERS.monitorInvoiceExportListForm.monitorInvoiceExports,
      PAGE_NUMBERS.monitorInvoiceExportListForm.monitorInvoiceExports,
      SECTION_CODES.monitorInvoiceExportListForm.monitorInvoiceExport,
      QUESTION_CODES.monitorInvoiceExportListForm.monitorInvoiceExportListFilter
    );

    return this.filterQuestionToFilterModelMapper.Map(filterModel);
  }
}
